import { observable } from 'mobx';

export type SupportFeeElementResponseArgs = {
  id: number;
  content: string;
};

export type SupportFeeElementArgs = {
  id: number;
  content: string;
};

export const convertSupportFeeElementResponseToArgs = (response: SupportFeeElementResponseArgs) => {
  const args: SupportFeeElementArgs = {
    id: response.id,
    content: response.content
  };
  return args;
};

export default class SupportFeeElement {
  @observable id: number;
  @observable content: string;

  constructor(args: SupportFeeElementArgs) {
    this.id = args.id;
    this.content = args.content;
  }

  get type() {
    return 'support_fee';
  }

  get startDate() {
    return null;
  }

  get endDate() {
    return null;
  }

  get title() {
    return '出張サポート費';
  }

  get summary() {
    return `[出張サポート費]${this.content}`;
  }

  get name() {
    return this.title;
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
